/** @format */

import React from 'react';

import {BrowserRouter, Route, Routes} from 'react-router-dom';

import {ViewAndAddPaymentProfile} from './components/payments/view_and_add_payment_profile/view_and_add_payment_profile';
import AdvancedQuoter from './components/advanced_quoter/container';
import ArchivedOrders from './components/archived_orders/container';
import {UserPaymentMethods} from './components/payments/container';
import ReorderOrders from './components/reorder_orders/container';
import InvoicesContainer from './components/invoices/container';
import ActiveOrders from './components/active_orders/container';
import {SavedOrders} from './components/saved_orders/container';
import UserCompanies from './components/companies/container';

import UserTextSetting from './user_text_setting';
import Order from './components/order/container';
import UserAddresses from './components/user_addresses/container';
import AccountNav from './components/layouts/nav/nav';

import CartConfirmation from 'frontier/cart/components/cart_confirmation/container';
import {ViewInvoice} from './components/invoices/view_invoice/view_invoice';
import CartOverview from 'frontier/cart/components/cart_overview/container';
import {Contact, ProductionPresets} from './components/details/container';
import Cart from 'frontier/cart/components/cart/container';
import ProofOrder from './components/proofing/container';

import {PreferencesNav} from './components/layouts/preferences_nav';
import {OrdersNav} from './components/layouts/orders_nav';

// application-scoped styles
import './namespaced_bs4.sass';
import './account.sass';

// Add the design system's global scope CSS to the page.
import '@/components/sttark_design_system/index.scss';

const AccountApp = () => {
    return (
        <BrowserRouter>
            <div
                id="account-router"
                data-sttark-pa="carts-a--934722"
                className="bs4 bs4-nav bs4-buttons bs4-modal bs4-form bs4-utils bs4-grid bs4-cards bs4-listgroup bs4-inputgroup bs4-badge"
                style={{paddingBottom: '40px'}}>
                <Routes>
                    <Route path="/account" element={<AccountNav />}>
                        {/*<Routes>*/}
                        <Route exact path="/account/orders/view/:id" element={<Order />} />
                        <Route
                            exact
                            path="/account"
                            element={
                                <OrdersNav>
                                    <ActiveOrders
                                        action="account/orders/index"
                                        searchKey="activeOrdersSearch"
                                    />
                                </OrdersNav>
                            }
                        />
                        <Route
                            exact
                            path="/account/orders/index"
                            element={
                                <OrdersNav>
                                    <ActiveOrders />
                                </OrdersNav>
                            }
                        />
                        <Route exact path="/account/orders/saved" element={<SavedOrders />} />
                        <Route
                            exact
                            path="/account/orders/archived"
                            element={
                                <OrdersNav>
                                    <ArchivedOrders />
                                </OrdersNav>
                            }
                        />
                        <Route
                            path="/account/users/account-details/contact"
                            element={
                                <PreferencesNav>
                                    <Contact />
                                </PreferencesNav>
                            }
                        />
                        <Route
                            path="/account/users/account-details/production-presets"
                            element={
                                <PreferencesNav>
                                    <ProductionPresets />
                                </PreferencesNav>
                            }
                        />
                        <Route
                            exact
                            path="/account/users/addresses"
                            element={
                                <PreferencesNav>
                                    <UserAddresses />
                                </PreferencesNav>
                            }
                        />
                        <Route
                            exact
                            path="/account/users/addresses/:addressType"
                            element={
                                <PreferencesNav>
                                    <UserAddresses />
                                </PreferencesNav>
                            }
                        />
                        <Route
                            exact
                            path="/account/users/payments"
                            element={
                                <PreferencesNav>
                                    <UserPaymentMethods />
                                </PreferencesNav>
                            }
                        />
                        <Route
                            exact
                            path="/account/users/payments/add"
                            element={
                                <PreferencesNav>
                                    <ViewAndAddPaymentProfile />
                                </PreferencesNav>
                            }
                        />
                        <Route exact path="/account/companies/index" element={<UserCompanies />} />
                        <Route
                            exact
                            path="/account/orders/advanced-quoter"
                            element={<AdvancedQuoter />}
                        />
                        <Route exact path="/account/charges/index" element={<InvoicesContainer />}>
                            <Route
                                path="/account/charges/index/:invoiceId"
                                element={<ViewInvoice />}
                            />
                        </Route>
                        <Route
                            exact
                            path="/account/proofs/view/:orderId"
                            element={<ProofOrder />}
                        />

                        <Route
                            exact
                            path="/account/orders/reorders"
                            element={
                                <OrdersNav>
                                    <ReorderOrders
                                        action="/account/orders/reorders"
                                        searchKey="reorderSearch"
                                    />
                                </OrdersNav>
                            }
                        />
                    </Route>
                </Routes>

                {/* cart */}
                <Routes>
                    <Route path="/cart" element={<CartOverview />} />
                    <Route path="/cart_confirmation" element={<CartConfirmation />} />
                    <Route path="/carts" element={<Cart />} />

                    <Route exact path="/cart_confirmation" element={<UserTextSetting />} />
                </Routes>
            </div>
        </BrowserRouter>
    );
};

export default AccountApp;
